import { useRef, } from 'react';
import BaseFilesServer, { BaseFilesServerProps } from '../../utilsTsx/components/files/BaseFilesServer';
import systematic from '../../config/systematic';

const FilesServer = (props: any) => {
    const ref = useRef<any>(undefined);
    const extendProps: BaseFilesServerProps = {
        defaultService: systematic.bmService
    }

    return (
        <>
            <BaseFilesServer {...extendProps} ref={ref} />
        </>
    )
}

export default FilesServer;